export default class UserSettingsModel {
    hideDisabledUsers: boolean = false;
    

    static from(json: string): UserSettingsModel {
        let model = Object.assign(new UserSettingsModel(), json);
        return model;
    }
}